import { useTranslation } from "react-i18next";
import { Note } from "../../../primitives/data-display/Note";

interface RateLimitCaptionProps {
  remaining: number;
  limit: number;
  minutesUntilReset: number;
}

/** Caption shown below the landing input once the verify quota is known. */
export function RateLimitCaption({ remaining, limit, minutesUntilReset }: RateLimitCaptionProps) {
  const { t } = useTranslation();

  if (remaining === 0) {
    return <Note color="warning.main">{t("rateLimit.message", { count: minutesUntilReset })}</Note>;
  }

  return (
    <Note color="text.secondary">
      {t("rateLimit.remainingChecks", { count: remaining, limit })}
      {" · "}
      {t("rateLimit.refreshesIn", { count: minutesUntilReset })}
    </Note>
  );
}
